<script setup lang="ts">
import { computed } from 'vue';
import { sanitizeRichText } from '../utils/sanitizeRichText';

type Props = {
  content: string;
};

const props = defineProps<Props>();

const html = computed(() => sanitizeRichText(props.content));
</script>

<template>
  <div
    v-if="html"
    class="vp-event-description text-vp-secondary-1-900 bg-vp-blue-300 p-2 sm:p-4 my-2 sm:my-4 rounded-sm w-full text-sm"
    v-html="html"
  />
</template>
